module.exports = __webpack_public_path__ + "img/login-bg-2.66b5bf5b.png";